import CONFIG from '../config';

/**
 * Validates if a candidate meets the minimum age requirement based on their division
 * @param {Date} dateOfBirth - The candidate's date of birth
 * @returns {Object} - { isValid: boolean, requiredAge: number, currentAge: number, message: string }
 */
export function validateAgeRequirement(dateOfBirth) {
    if (!dateOfBirth) {
        return {
            isValid: false,
            requiredAge: 0,
            currentAge: 0,
            message: 'Date of birth is required'
        };
    }

    const currentDate = new Date();
    const birthDate = new Date(dateOfBirth);
    
    // Calculate current age
    let currentAge = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
        currentAge--;
    }

    // Determine required age based on division
    const division = CONFIG.currentDivision?.toLowerCase();
    let requiredAge;
    let divisionName;

    switch (division) {
        case 'ss':
            requiredAge = 16;
            divisionName = 'Store Support';
            break;
        case 'st':
        case 'sc':
            requiredAge = 18;
            divisionName = division === 'st' ? 'Stock Taking' : 'Supply Chain';
            break;
        default:
            requiredAge = 18;
            divisionName = 'this division';
    }

    const isValid = currentAge >= requiredAge;
    
    let message = '';
    if (!isValid) {
        message = `You must be at least ${requiredAge} years old to apply for ${divisionName} positions. You are currently ${currentAge} years old.`;
    }

    return {
        isValid,
        requiredAge,
        currentAge,
        message
    };
}

/**
 * Gets the minimum age requirement for the current division
 * @returns {number} - The minimum age requirement
 */
export function getMinimumAgeRequirement() {
    const division = CONFIG.currentDivision?.toLowerCase();
    
    switch (division) {
        case 'ss':
            return 16;
        case 'st':
        case 'sc':
            return 18;
        default:
            return 18;
    }
}
